import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authenticatedFetch } from "../../../network/api";
import RequestComplete from "./assets/requestComplete.png";
import "./success.css";
import SearchHeader from "../../searchResults/searchHeader";

const Success = () => {
  const [status, setStatus] = useState(null);
  const [metadata, setMetadata] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get("session_id");
    const connectedAccountId = urlParams.get("connectedAccountId");

    authenticatedFetch(
      `/api/client/webapp/getCheckoutSessionStatus?session_id=${sessionId}&connectedAccountId=${connectedAccountId}`
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("Checkout session data:", data);
        const paymentMetadata = data.paymentIntentMetadata;
        setMetadata(paymentMetadata);
        setStatus(data.status);

                  // Once metadata is fetched, extract the requestId and update the payment status via API
          if (paymentMetadata && paymentMetadata.requestId) {
            authenticatedFetch("/api/client/updateAppointmentRequestPaymentStatus", {
              method: "PUT",
              body: JSON.stringify({
                appointment_request_id: paymentMetadata.requestId,
              }),
            })
            .then((res) => res.json())
            .then((updateData) => {
              console.log("Payment status updated:", updateData);
            })
            .catch((err) => {
              console.error("Error updating payment status:", err);
            });
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching checkout session status:", err);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (status !== "complete") {
    return <p className="confirmation-container">Error</p>;
  }

  return (
    <div>
      <SearchHeader searchBar={false} headerColor="search-header-gray" />
      <div className="confirmation-container">
        <div className="confirmation-message">
          <img src={RequestComplete} alt="Success" className="success-icon" />
          <h1 className="confirmation-title">Request Successfully Sent!</h1>
          <p className="confirmation-content">
            Your appointment request has been successfully sent to the lawyer.
            <strong>A temporary authorization hold has been placed on your card for ${metadata.price || "0.00"}.</strong>
            The amount will only be charged once the lawyer confirms your appointment.
            Once confirmed, you'll receive a confirmation message and can track
            the progress in{" "}
            <span
              className="my-appt-span"
              onClick={() => {
                navigate("/client/my-appointments");
              }}
            >
              My Appointments
            </span>
            .
          </p>
        </div>

        <div className="appt-details">
          <h2 className="confirmation-box-title">
            {metadata.appointmentName || "Appointment Name"}
          </h2>
          <div className="lawyer-details-div">
            <img
              src={metadata.lawyerPhoto || "default-photo.png"}
              alt="Lawyer"
              className="lawyer-photo"
            />
            <div className="lawyer-details-content">
              <h3 className="confirmation-lawyer-name">
                {metadata.lawyerName || "Unknown Lawyer"}
              </h3>
              <p className="content-font">
                {metadata.practiceAreas || "No Practice Areas Available"}
              </p>
              <p className="content-font">
                {metadata.date}, {metadata.startTime} (1 hour)
              </p>
              <p>
                <strong className="content-font">
                  Total Amount: ${metadata.price || "0.00"}
                </strong>
              </p>
            </div>
          </div>
        </div>

        <button
          className="continue-button-success"
          onClick={() => {
            navigate("/");
          }}
        >
          Finish
        </button>
      </div>
    </div>
  );
};

export default Success;
